"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _useInterval = _interopRequireDefault(require("@eig-builder/core-utils/hooks/useInterval"));

require("./style/notification.scss");

var ImageLibraryNotification = function ImageLibraryNotification(_ref) {
  var type = _ref.type,
      message = _ref.message,
      active = _ref.active,
      hideAfter = _ref.hideAfter,
      hideAfterCallback = _ref.hideAfterCallback,
      icon = _ref.icon;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      internalActive = _React$useState2[0],
      setActive = _React$useState2[1];

  _react["default"].useEffect(function () {
    setActive(true);
  }, [hideAfter]);

  (0, _useInterval["default"])(function () {
    if (hideAfter) {
      setActive(false);
    }
  }, hideAfter);
  var formattedMessages = Array.isArray(message) ? message.map(function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index
    }, child);
  }) : message;

  if (hideAfter) {
    var classes = (0, _classnames["default"])('image-library-notification', type, {
      active: internalActive
    });
    var spacerClasses = (0, _classnames["default"])('image-library-notification-spacer', {
      active: internalActive
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: spacerClasses
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes
    }, formattedMessages, icon && /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon-spacer"
    }, icon)));
  } else {
    var _classes = (0, _classnames["default"])('image-library-notification', type);

    var _spacerClasses = (0, _classnames["default"])('image-library-notification-spacer', {
      active: active
    });

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _spacerClasses
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _classes
    }, formattedMessages, icon && /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon-spacer"
    }, icon)));
  }
};

ImageLibraryNotification.propTypes = {
  type: _propTypes["default"].string,
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  active: _propTypes["default"].bool,
  hideAfter: _propTypes["default"].number,
  hideAfterCallback: _propTypes["default"].func,
  icon: _propTypes["default"].node
};
var _default = ImageLibraryNotification;
exports["default"] = _default;